/* global angular, $, TweenMax */
angular.module('ua5App')
    .directive('globalHeader', ['ModalService', '$rootScope', 'TRANSITION', '$state', function(ModalService, $rootScope, TRANSITION, $state) {
        return {
            restrict: 'A',
            templateUrl: 'components/global-header/global-header.html',
            controller: ['$scope', '$element', function($scope, $element) {
                var $$element;
                var $$header;
                var initialized;
                var self;
                $$element = $($element);
                $$header = $$element.find('.global-header');
                self = this;
                $scope.menuLink = 'Menu';

                // Resets the position of the header to its default state.
                function resetHeaderPos(cb) {

                    TweenMax.to($$header, TRANSITION.DUR, {
                        left: 84,
                        right: 84,
                        ease: TRANSITION.EASE,
                        onComplete: cb,
                        delay: 1
                    });
                }

                function moveHeaderLeft(cb) {
                    TweenMax.to($$header, TRANSITION.DUR, {
                        left: 32,
                        right: 212,
                        ease: TRANSITION.EASE,
                        onComplete: cb,
                        delay: 1
                    });
                }

                function moveHeaderRight(cb) {
                    TweenMax.to($$header, TRANSITION.DUR, {
                        left: 212,
                        right: 32,
                        ease: TRANSITION.EASE,
                        onComplete: cb,
                        delay: 1
                    });
                }

                function makeHeaderWider(cb) {
                    TweenMax.to($$header, TRANSITION.DUR, {
                        left: 34,
                        right: 34,
                        ease: TRANSITION.EASE,
                        onComplete: cb
                    });
                }

                // Depending on the state, move the header, left, right or
                // reset. Takes the `toState` object as an argument.
                function moveHeader(toState) {
                    var name;
                    name = toState.name;
                    if (name === 'home.resources') {
                        moveHeaderRight();
                    } else if (name === 'home.community') {
                        moveHeaderLeft();
                    } else if (name === 'calendar' || name === 'single') {
                        $('.posts-filter').removeClass('inHome');
                        makeHeaderWider();
                    } else {
                        $('.posts-filter').addClass('inHome');
                        resetHeaderPos();
                    }
                }

                $scope.goHome = function() {
                    $rootScope.$broadcast('globalHeader:logo:clicked');
                    $state.go('home');
                };

                // Move the header as soon as the `$stateChangeStart` event
                // fires. Determine which direction to move the header in the
                // `moveHeader` function.
                $scope.$on('$stateChangeStart', function(e, toState) {
                    moveHeader(toState);
                });

                // Transition the position of the header if it needs to move
                // over on first load.
                $scope.$on('$stateChangeSuccess', function(e, toState) {
                    if (!initialized) {
                        moveHeader(toState);
                        initialized = true;
                    }
                });

                self.toggleMenuOpen = function() {
                    $scope.menuOpen = self.menuOpen = !$scope.menuOpen;
                    $scope.menuLink = $scope.menuOpen ? 'Close' : 'Menu';
                };

                $scope.searchOpen = false;
                $scope.openSearch = function(l) {
                    if (!$scope.searchOpen) {
                        if ($scope.menuOpen) {
                            $scope.$emit('globalHeader:menu:closed');
                        }

                        ModalService.showModal({
                            templateUrl: 'components/search/search.html',
                            controller: 'SearchCtrl',
                            controllerAs: 'ctrl'
                        });

                    } else {
                        $rootScope.$broadcast('globalHeader:search:closed');
                    }

                    $scope.searchOpen = !$scope.searchOpen;
                };

                $scope.$on('globalHeader:search:destroy', function(e) {

                    $scope.$apply(function() {
                        $scope.searchOpen = false;
                        TweenMax.set($$header, {
                            background: 'rgba(255, 255, 255, 0.9)'
                        });
                    });
                });

                $scope.$on('globalHeader:search:create', function(e) {
                    $scope.searchOpen = true;
                    TweenMax.set($$header, {
                        background: 'rgba(255, 255, 255, 0)'
                    });
                });

                $scope.showMenu = function() {
                    if ($scope.menuOpen) {
                        $scope.$emit('globalHeader:menu:closed');
                    } else {
                        $scope.$emit('globalHeader:menu:opened');

                        //close search if open
                        $rootScope.$broadcast('globalHeader:search:closed');
                    }
                };
            }]
        };
    }])
;
